import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

import { UserService, OrganizationType } from 'shared/services';
import { AuthService } from '@auth0/auth0-angular';
import { retailersUrlPrefix } from 'src/app/retailer-platform/brand-shop/utils';

@Injectable()
export class AdminGuard {
    constructor(
        private userService: UserService,
        private auth0Service: AuthService,
        private router: Router
    ) {}

    public canActivate() {
        return combineLatest([this.userService.user$, this.auth0Service.user$]).pipe(
            map(([user, auth0User]) => {
                const organizationType = user?.organization?.type || auth0User?.org_type;
                if (organizationType === OrganizationType.Admin) {
                    return true;
                }

                if (organizationType === OrganizationType.Retailer) {
                    return this.router.parseUrl(`${retailersUrlPrefix}/home`);
                }

                if (organizationType === OrganizationType.Manufacturer) {
                    return this.router.parseUrl('news');
                }

                return false;
            })
        );
    }
}
